import React from 'react'
import {
  Button,
  Field,
  Input,
  Select,
  StepsNextTrigger,
  StepsPrevTrigger,
} from '@lightspeed/unified-components-helios-theme/react'
import {
  CONTACT_OPTIONS,
  CUSTOMER_NAME_FIELD,
  CustomerInfo,
} from '../../../../common/types'
import { FulfilmentType } from '../../../../../../../models/fulfilment'
import { STEPS } from '../../types'
import { StepBreadcrumbs } from '../../StepBreadcrumbs/StepBreadcrumbs'
import { useStep2AddModel } from './useStep2AddModel'

export interface Step2AddProps {
  onStepChange: (step: STEPS) => void
  onClose: () => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  type: FulfilmentType
  newCustomer: CustomerInfo | null
}

export const Step2Add: React.FC<Step2AddProps> = props => {
  const models = useStep2AddModel(props)

  return (
    <div className="uc-base w-[640px] max-w-[calc(100vw-2rem)] rounded-lg bg-bg-neutral-top shadow-elevated">
      <StepBreadcrumbs
        step={STEPS.ADD}
        isAddingCustomer={Boolean(props.newCustomer)}
        onStepChange={props.onStepChange}
      >
        <div className="px-8 pt-6">
          <h2 className="typography-heading-md text-fg-neutral-default">
            {models.title}
          </h2>
          <p className="mt-2 typography-body-sm text-fg-neutral-soft">
            {models.description}
          </p>
        </div>
        <div className="px-8 py-5">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Field labelSlot={models.firstNameLabel}>
              <Input
                name={CUSTOMER_NAME_FIELD.FIRSTNAME}
                placeholder={models.firstNamePlaceholder}
                value={props.newCustomer?.firstName || ''}
                onChange={(value: string) =>
                  models.handleInputChange(CUSTOMER_NAME_FIELD.FIRSTNAME, value)
                }
              />
            </Field>
            <Field labelSlot={models.lastNameLabel}>
              <Input
                name={CUSTOMER_NAME_FIELD.LASTNAME}
                placeholder={models.lastNamePlaceholder}
                value={props.newCustomer?.lastName || ''}
                onChange={(value: string) =>
                  models.handleInputChange(CUSTOMER_NAME_FIELD.LASTNAME, value)
                }
              />
            </Field>
            <Field labelSlot={models.contactNumberLabel}>
              <div className="flex gap-2">
                <Select
                  value={models.contactOption}
                  options={models.contactOptions}
                  onChange={models.handleContactOptionChange}
                  customClasses={{
                    container: 'w-32 shrink-0',
                  }}
                />
                <Input
                  name={models.contactOption}
                  placeholder={models.contactNumberPlaceholder}
                  type="tel"
                  value={models.contactNumber}
                  onChange={models.handleContactNumberChange}
                />
              </div>
            </Field>
            <Field labelSlot={models.emailLabel}>
              <Input
                invalid={models.isEmailInvalid}
                name={CONTACT_OPTIONS.EMAIL}
                placeholder={models.emailPlaceholder}
                type="email"
                value={props.newCustomer?.email || ''}
                onChange={(value: string) =>
                  models.handleInputChange(CONTACT_OPTIONS.EMAIL, value)
                }
              />
            </Field>
          </div>
        </div>
        <div className=" flex justify-end gap-2 border-t border-border-neutral-soft px-8">
          <StepsPrevTrigger>
            <Button
              appearance="secondary"
              customDataAttributes={{
                container: { 'data-track': 'back-customer-step' },
              }}
            >
              {models.backLabel}
            </Button>
          </StepsPrevTrigger>
          <StepsNextTrigger>
            <Button
              disabled={models.isNextDisabled}
              appearance="primary"
              customDataAttributes={{
                container: { 'data-track': 'next-details-step' },
              }}
            >
              {models.nextLabel}
            </Button>
          </StepsNextTrigger>
        </div>
      </StepBreadcrumbs>
    </div>
  )
}

Step2Add.displayName = 'Step2Add'
